export enum DanceEventStatusEnum {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  DELETED = 'DELETED',
  PAST = 'PAST'
}
